module.exports = __webpack_public_path__ + "static/media/uae-logo.b3eb6379.png";